import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Input } from '@/shared/components/Input';
import { Select } from '@/shared/components/Select';
import { Button } from '@/shared/components/Button';
import { ApiError } from '@/lib/api-client';
import { useOppositions } from '@/features/director-professors/hooks/useSubjects';
import { useCreateStudentInvitation } from '../hooks/useStudentInvitations';
export function InviteStudentForm({ onSuccess, initialEmail = '', initialOppositionId = '', prospectId, }) {
    const [serverError, setServerError] = useState(null);
    const create = useCreateStudentInvitation();
    const { data: oppositions = [], isLoading: oppLoading } = useOppositions();
    const enabledOppositions = oppositions.filter((o) => o.is_enabled);
    const { register, handleSubmit, setValue, watch, formState: { errors }, } = useForm({
        defaultValues: { email: initialEmail, opposition_id: initialOppositionId, start_date: '' },
    });
    const oppositionId = watch('opposition_id');
    useEffect(() => {
        if (!oppositionId && enabledOppositions[0]) {
            setValue('opposition_id', enabledOppositions[0].id);
        }
    }, [enabledOppositions, oppositionId, setValue]);
    function onSubmit(values) {
        setServerError(null);
        if (!values.opposition_id) {
            setServerError('Selecciona una oposición.');
            return;
        }
        create.mutate({
            email: values.email.trim().toLowerCase(),
            opposition_id: values.opposition_id,
            ...(prospectId ? { prospect_id: prospectId } : {}),
            ...(values.start_date ? { start_date: values.start_date } : {}),
        }, {
            onSuccess: () => onSuccess(),
            onError: (err) => {
                setServerError(messageForError(err));
            },
        });
    }
    return (_jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "space-y-4", children: [_jsx("p", { className: "text-sm text-gray-600 dark:text-gray-400 leading-relaxed", children: "Le enviaremos un email al alumno con un enlace para que complete su ficha (datos personales, foto, turno, contrase\u00F1a y aceptaci\u00F3n del tratamiento de datos). El enlace caduca en 7 d\u00EDas." }), _jsx(Input, { label: "Email del alumno", type: "email", autoComplete: "off", error: errors.email?.message, ...register('email', {
                    required: 'El email es obligatorio',
                    pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: 'Email inválido',
                    },
                }) }), _jsx(Select, { label: "Oposici\u00F3n", options: [
                    { value: '', label: oppLoading ? 'Cargando…' : 'Selecciona…' },
                    ...enabledOppositions.map((o) => ({ value: o.id, label: o.name })),
                ], error: errors.opposition_id?.message, ...register('opposition_id', { required: 'Selecciona una oposición' }) }), _jsx(Input, { label: "Fecha de inicio (opcional)", type: "date", hint: "Si empieza m\u00E1s adelante, no aparecer\u00E1 al pasar lista ni se le generar\u00E1n mensualidades hasta ese mes. Vac\u00EDo = empieza al aceptar la invitaci\u00F3n.", ...register('start_date') }), serverError && (_jsx("div", { className: "rounded-md border border-red-300 dark:border-red-500/40 bg-red-50 dark:bg-red-500/10 px-3 py-2 text-sm text-red-700 dark:text-red-200", children: serverError })), _jsx("div", { className: "flex justify-end pt-2", children: _jsx(Button, { type: "submit", loading: create.isPending, children: "Enviar invitaci\u00F3n" }) })] }));
}
function messageForError(err) {
    if (!(err instanceof ApiError))
        return 'Ha ocurrido un error.';
    switch (err.code) {
        case 'STUDENT_EMAIL_ALREADY_EXISTS':
            return 'Ya existe un usuario con ese email.';
        case 'STUDENT_INVITATION_ALREADY_SENT':
            return 'Ya hay una invitación pendiente para ese email. Cancélala antes de crear una nueva.';
        case 'FEATURE_DISABLED':
            return 'La oposición seleccionada no está habilitada.';
        case 'PROSPECT_ALREADY_ENROLLED':
            return 'El posible alumno ya fue matriculado.';
        default:
            return err.message;
    }
}
//# sourceMappingURL=InviteStudentForm.js.map